// FormDataContext.js
import { createContext } from 'react';

const FormDataContext = createContext({});

export default FormDataContext;
